import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgreementAcceptComponent } from './agreement-accept.component';
import { AgreementAcceptModalService } from './agreement-accept.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CheckParentModule } from '../check-parent/check-parent.module';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    CheckParentModule,
  ],
  declarations: [
    AgreementAcceptComponent
  ],
  providers:[
    AgreementAcceptModalService,
  ],
  entryComponents: [
    AgreementAcceptComponent
  ],
})
export class AgreementAcceptModule { }
